import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DownloadAppStore from "../../components/DownloadAppStore";
import DownloadGoogle from "../../components/DownloadGoogle";
import logoYellow from "../../assets/images/icons/logoYellow.svg";
import {
  detectDevice,
  getAndroidStoreUrlWithReferrer,
  getStoreUrls,
  SIGNIN_ANDROID_REFERRER,
  type DeviceType,
} from "../../utils/appStore";
import "./SigninLandingPage.scss";

const SigninLandingPage = () => {
  const location = useLocation();
  const [device, setDevice] = useState<DeviceType>("desktop");
  const { ios: iosStoreUrl, android: androidStoreUrl, staging } = getStoreUrls(
    location.pathname
  );

  useEffect(() => {
    setDevice(detectDevice());
  }, []);

  const navigateToStore = useCallback(() => {
    if (device === "ios") {
      window.location.href = iosStoreUrl;
      return;
    }

    if (device === "android") {
      window.location.href = getAndroidStoreUrlWithReferrer(
        androidStoreUrl,
        SIGNIN_ANDROID_REFERRER,
        staging
      );
    }
  }, [androidStoreUrl, device, iosStoreUrl, staging]);

  const handleStoreClick = useCallback(
    (store: "ios" | "android") => {
      if (store === "ios") {
        window.open(iosStoreUrl, "_blank", "noopener,noreferrer");
        return;
      }

      const url = getAndroidStoreUrlWithReferrer(
        androidStoreUrl,
        SIGNIN_ANDROID_REFERRER,
        staging
      );
      window.open(url, "_blank", "noopener,noreferrer");
    },
    [androidStoreUrl, iosStoreUrl, staging]
  );

  return (
    <div className="signin-landing-page">
      <img className="signin-landing-page__logo" src={logoYellow} alt="FAM" />

      <div className="signin-landing-page__content">
        <h1 className="signin-landing-page__title">Update Required</h1>
        <p className="signin-landing-page__body">
          A new and improved FAM is here.
          <br />
          Update to the latest version to unlock the latest features and continue using the app.
        </p>
      </div>

      {device === "desktop" ? (
        <div className="signin-landing-page__desktop-stores">
          <button
            type="button"
            onClick={() => handleStoreClick("ios")}
            className="signin-landing-page__store-btn"
            aria-label="Download on the App Store"
          >
            <DownloadAppStore color={undefined} style={{ height: 48 }} />
          </button>
          <button
            type="button"
            onClick={() => handleStoreClick("android")}
            className="signin-landing-page__store-btn"
            aria-label="Get it on Google Play"
          >
            <DownloadGoogle color={undefined} style={{ height: 48 }} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          className="signin-landing-page__cta"
          onClick={navigateToStore}
          aria-label="Update now — go to app store"
        >
          Update now
        </button>
      )}
    </div>
  );
};

export default SigninLandingPage;
